import { render, staticRenderFns } from "./SupplementaryInsuranceExtend.vue?vue&type=template&id=c351d3e0"
import script from "./SupplementaryInsuranceExtend.vue?vue&type=script&lang=js"
export * from "./SupplementaryInsuranceExtend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports